import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

import { BACKEND_URL } from "../../config";

const SUPPORTED_CHAIN_IDS = ["97", "56", "42161"];

export const useNameResolver = (chainId, address) => {
  const requestCache = useRef({});
  const [name, setName] = useState<null | string>(null);

  const resolveName = useCallback(async () => {
    if (!address || !SUPPORTED_CHAIN_IDS.includes(chainId)) {
      return;
    }
    const cacheKey = `${chainId}-${address}`;

    if (requestCache.current[cacheKey]) {
      setName(requestCache.current[cacheKey]);
      return;
    }
    const url = `${BACKEND_URL}/spaceId/${chainId}/${address}`;
    const result = await axios.get(url);

    requestCache.current[cacheKey] = result?.data?.name;
    setName(result?.data?.name?.name);
  }, [chainId, address]);

  useEffect(() => {
    resolveName();
  }, [resolveName]);

  return { name };
};

export default useNameResolver;
